export const isClient = () => process.client;
